import React from 'react';
import {Button, Form, Modal, ModalContent} from 'semantic-ui-react';
import DatePicker from "react-datepicker";
import ru from "date-fns/locale/ru";
import {getPatientTitle, PatientTitleCase,} from "../../../utils/common";
import styles from "../index.module.css";
import agent from "../../../agent";
import {TaskModel} from "../../workTableTask/TaskModel";
import {handleDatePickerKeyDown} from '../../../helpers/CalendarEventsRepeater';
import moment from "moment";
import { textLabels } from '../../../consts/textLabels';
import MaskedDatePicker from '../../general/MaskedDatePicker';

interface State {
    openModal: boolean,
    loading: boolean,
    isExporting: boolean,
    startDate: Date | null,
    endDate: Date | null,
}

interface Props {
    onClose: (task?: TaskModel) => void;
}

class PatientsAnswerModal extends React.Component<Props> {
    state: State = {
        openModal: true,
        loading: false,
        isExporting: false,
        startDate: new Date(),
        endDate: new Date(),
    };

    clearState = (task?: TaskModel): void => {
        this.setState({
            openModal: false,
            //startDate: null,
            //endDate: null,
            loading: false
        }, () => {
            this.props.onClose(task); // Call the onClose callback passed from the parent
        });
    };


    exportPatientsAnswer = async (): Promise<void> => {
        if (!this.state.startDate || !this.state.endDate) return;
        this.setState({loading: true});
        let task = await agent.PatientProvider.exportPatientAnswers(
            moment(this.state.startDate).format('YYYY-MM-DD'),
            moment(this.state.endDate).format('YYYY-MM-DD'));
        this.clearState(task)
    };

    render() {
        const headerLabel: string = `Экспорт ответов ${getPatientTitle(PatientTitleCase.ov)}`;
        const exportLabel: string = `Экспортировать`;
        const cancelLabel: string = textLabels.cancelButton;

        return (
            <div className={styles.container}>

                <Modal
                    onClose={() => this.clearState()}
                    open={this.state.openModal}
                    closeIcon
                >
                    <Modal.Header>{headerLabel}</Modal.Header>
                    <ModalContent>
                        <Form>
                            <div>
                                <label>Дата начала выгрузки</label><br/>
                                <MaskedDatePicker
                                    selected={this.state.startDate}
                                    onChange={(date?: Date) => {
                                        if (!date) {
                                            this.setState({
                                                startDate: null,
                                                endDate: null
                                            });
                                        } else {
                                            this.setState({
                                                startDate: date,
                                                endDate: date
                                            });
                                        }
                                    }}
                                    onKeyDown={handleDatePickerKeyDown}
                                />
                            </div>

                            <div style={{marginTop: '15px'}}>
                                <label style={{marginTop: '10px'}}>Дата окончания выгрузки</label><br/>
                                <MaskedDatePicker
                                    selected={this.state.endDate}
                                    onChange={(date?: Date) => {
                                        this.setState({
                                            endDate: date ?? null
                                        });
                                    }}
                                    onKeyDown={handleDatePickerKeyDown}
                                    minDate={this.state.startDate || undefined}
                                    maxDate={this.state.startDate ? new Date(this.state.startDate.getTime() + 6 * 24 * 60 * 60 * 1000) : undefined}
                                />
                            </div>
                        </Form>
                    </ModalContent>
                    <Modal.Actions>
                        <Button
                            content={exportLabel}
                            onClick={this.exportPatientsAnswer}
                            positive
                            disabled={!this.state.startDate || !this.state.endDate}
                        />
                        <Button
                            color={'grey'}
                            onClick={() => this.clearState()}
                        >
                            {cancelLabel}
                        </Button>
                    </Modal.Actions>
                </Modal>

            </div>

        );
    }
}

export default PatientsAnswerModal;
